import { useCallback, useEffect, useLayoutEffect, useState } from "react";

function useToggleRender(
  transiConfig = { enterDuration: -50, exitDuration: null, classNamePrefix: "" }
) {
  const [active, setActive] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [transitionClass, setTransitionClass] = useState("exited");
  const { enterDuration, exitDuration, classNamePrefix } = transiConfig;

  // Adding transition
  useEffect(() => {
    let delayTransition;
    let nestedDelay;

    if (active) {
      setMounted(true);
      setTransitionClass("exited");
      // Adding transition after mounted
      delayTransition = setTimeout(() => {
        setTransitionClass(`entering`);
      }, 30);
      nestedDelay = setTimeout(() => {
        setTransitionClass(`entered`);
      }, enterDuration + 50);
    } else {
      setTransitionClass(`exiting`);
      // Unmounting after transition
      delayTransition = setTimeout(() => {
        setTransitionClass(`exited`);
        setMounted(false);
      }, (exitDuration || enterDuration) + 50);
    }

    return () => {
      clearTimeout(delayTransition);
      clearTimeout(nestedDelay);
    };
  }, [active, enterDuration, exitDuration]);

  const toggle = () => setActive((prevState) => !prevState);
  const activate = () => setActive(true);
  const deactivate = () => setActive(false);

  return {
    active,
    mounted,
    toggle,
    activate,
    deactivate,
    transitionClass:
      (classNamePrefix ? `${classNamePrefix}-` : "") + transitionClass,
    // (classNamePrefix || "") + transitionClass,
  };
}

export default useToggleRender;
